import LegalPage, { P, UL, Strong } from "@/components/LegalPage";

const sections = [
  {
    id: "information-we-collect",
    heading: "Information We Collect",
    body: (
      <>
        <P>
          We collect business information necessary to act as your purchasing
          agent and intermediary:
        </P>
        <UL
          items={[
            <>
              <Strong>Corporate Data:</Strong> Company name, EIN/Tax ID,
              account representatives, phone numbers, and business
              addresses.
            </>,
            <>
              <Strong>Purchase Specifications:</Strong> Manufacturing
              requirements, desired inventory lists, production volumes, and
              budgets that the Client provides to us in order to find
              suitable suppliers.
            </>,
            <>
              <Strong>Financial Data:</Strong> Information needed to issue
              and settle B2B invoices via secure bank invoicing and wire
              transfer, or — as a secondary option — processed directly by
              third-party payment gateways (Stripe) for the collection of
              our consulting fees.
            </>,
          ]}
        />
      </>
    ),
  },
  {
    id: "use-of-information",
    heading: "Use of Information",
    body: (
      <>
        <P>
          We use the collected data exclusively for B2B operational
          purposes:
        </P>
        <UL
          items={[
            "Identify and connect your company with Dominican suppliers that meet your requirements.",
            "Facilitate communication and drafting of commercial agreements.",
            "Process payments for our intermediation services securely.",
            "Comply with relevant trade and tax regulations.",
          ]}
        />
      </>
    ),
  },
  {
    id: "data-protection-and-sharing",
    heading: "Data Protection and Sharing",
    body: (
      <>
        <P>
          PS GLOBAL SERIES, LLC does{" "}
          <Strong>NOT sell or commercialize</Strong> your corporate data or
          product specifications to third parties. We will only share the
          necessary technical information (such as purchase volumes or
          quality specifications) with pre-selected suppliers in the
          Dominican Republic for the express purpose of obtaining quotes and
          facilitating your commercial transaction.
        </P>
        <P>
          We may disclose information to government authorities if strictly
          required by import/export laws or legal processes in the United
          States or the Dominican Republic.
        </P>
      </>
    ),
  },
  {
    id: "information-security",
    heading: "Information Security",
    body: (
      <P>
        We implement industry-standard security protocols (including
        encryption and restricted access) to protect your product
        specifications and the details of your commercial negotiations
        against unauthorized access or data leakage.
      </P>
    ),
  },
  {
    id: "policy-updates",
    heading: "Updates to this Policy",
    body: (
      <P>
        We reserve the right to modify this policy at any time to reflect
        updates in our commercial intermediation practices. Updates will
        take effect upon publication on psglobalseries.com.
      </P>
    ),
  },
  {
    id: "privacy-contact",
    heading: "Privacy Contact",
    body: (
      <P>
        For inquiries about the handling of your commercial data or the
        confidentiality of your manufacturing projects, contact us at:{" "}
        <a
          href="mailto:info@psglobalseries.com"
          className="text-slate-900 font-semibold hover:text-[#B45309]"
        >
          info@psglobalseries.com
        </a>
        .
      </P>
    ),
  },
];

export default function PrivacyPolicy() {
  return (
    <LegalPage
      testId="page-privacy-policy"
      eyebrow="Legal"
      title="Privacy Policy"
      lastUpdated="June 2026"
      intro={
        <>
          At PS GLOBAL SERIES, LLC, the confidentiality of your international
          commercial negotiations is our priority. This Privacy Policy
          explains how we handle corporate data when facilitating cross-border
          trade between the United States and the Dominican Republic.
        </>
      }
      sections={sections}
    />
  );
}
